"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __importDefault(require("firebase/app"));
require("firebase/firestore");
var domain_1 = require("../types/domain");
var actions = function (router, appConfig) { return ({
    getUserList: function (_a) {
        var commit = _a.commit;
        Promise.all([
            app_1.default.firestore().collection('users').get(),
            app_1.default.firestore().collection('roles').get()
        ])
            .then(function (_a) {
            var usersSnapshot = _a[0], rolesSnapshot = _a[1];
            var roles = rolesSnapshot.docs
                .map(function (d) { return Object.assign(d.data(), { id: d.id }); })
                .reduce(function (p, doc) {
                var _a;
                return Object.assign(p, (_a = {}, _a[doc.id] = doc, _a));
            }, {});
            var users = usersSnapshot.docs
                .map(function (d) { return Object.assign(d.data(), { id: d.id }); })
                .map(function (d) {
                var userRoles = roles[d.id] || {};
                delete userRoles.id;
                return Object.assign(d, { roles: userRoles });
            })
                .reduce(function (p, doc) {
                var _a;
                return Object.assign(p, (_a = {}, _a[doc.id] = doc, _a));
            }, {});
            commit('setUserList', users);
        })
            .catch(function (err) { return console.error(err); }); // eslint-disable-line no-console
    },
    setRoles: function (_a, _b) {
        var commit = _a.commit;
        var targetUser = _b.targetUser;
        var coll = app_1.default.firestore().collection('roles');
        return coll.doc(targetUser.uid).update(targetUser.roles)
            .catch(function () {
            return coll.doc(targetUser.uid).set(targetUser.roles);
        })
            .then(function () {
            commit('exchangeUser', targetUser);
        })
            .catch(function (err) { return console.error(err); }); // eslint-disable-line no-console
    },
    logout: function (_a) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit('blips/setLoading', true, { root: true });
                        commit('user/setLoginState', domain_1.LoginState.LOGOUT_PENDING, { root: true });
                        return [4 /*yield*/, app_1.default.auth().signOut()];
                    case 1:
                        _b.sent();
                        commit('blips/reset', null, { root: true });
                        commit('user/reset', null, { root: true });
                        commit('blips/setLoading', false, { root: true });
                        return [2 /*return*/];
                }
            });
        });
    }
}); };
exports.default = actions;
